module.exports = __webpack_public_path__ + "img/part_6_5.532cb301.png";